import React, { useState, useContext } from 'react';
import './story.css';
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import swal from 'sweetalert';
import {Redirect} from 'react-router-dom';
import {AuthContext} from '../../auth';


const AddPeoplestory = () => {

    const [story, setStory] = useState('');
    const [youtube, setYoutube] = useState('')
    const [added,setadded] = useState('false')
    const [logedinuser,setLogedinuser] = useContext(AuthContext);


    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log(e)
        // const f = () => {
            
        // }
        // f();
        const PeopleStories = Parse.Object.extend('PeopleStories');
            const peopleStories = new PeopleStories();
    
            peopleStories.set("story", story);
            peopleStories.set("youtube", youtube);
            peopleStories.set("personid",logedinuser);
            const shortstory = story.substring(0,30);
            peopleStories.set("shortstory",shortstory);
    
            peopleStories.save()
                .then((data) => {
                    console.log(data);
                    swal("Added!", "Your inspirational story has been shared to the world", "success");
                    setStory("");
                    setYoutube("");
                    setadded("true");
    
                }, function (error) {
                    // alert("please retry");
                    console.log(error);
                    swal("Oops!", "Seems like we couldn't add your story...Please try again in sometime", "error");
                    setStory("");
                    setYoutube("");
                })

    }
    return (
        <div>
            {console.log(logedinuser)}
            {(logedinuser === null)
            &&(
            <div>
                {swal("Oops!", "Please login to add your story")}
            </div>)
             && (<Redirect to={{
                     pathname:'/login',
                     re:'/dependantstories/route'
                    }} />)}
            {(added === "true") && (<Redirect to='/dependantstories/route'/>)}
            <Navbar head="Share Story" />
            <div className="container" style={{marginTop:"88px"}}>
                <form onSubmit={handleSubmit}>

                    <div className="form-group col-lg-12">
                        <textarea
                            className="textbox"
                            value={story}
                            onChange={e => setStory(e.target.value)}
                            placeholder="add your story ..." />
                    </div>
                    <div className="form-group col-lg-12  ">
                        <input
                            disabled
                            type="text"
                            className="form-control"
                            value={youtube}
                            onChange={e => setYoutube(e.target.value)}
                            placeholder="paste youtube link.." />
                    </div>
                    <div className="btndiv">
                        <input
                        type="submit"
                            className="submit btn-primary center-block mt-4" />
                    </div>
                </form>
            </div>
        </div>
    )
}
export default AddPeoplestory;